import React, { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { FileText, Loader2, Printer } from "lucide-react";

export async function fetchPdf(path, params, mode, filename) {
  try {
    const r = await api.get(path, { params, responseType: "blob", timeout: 300000 });
    const href = URL.createObjectURL(new Blob([r.data], { type: "application/pdf" }));
    if (mode === "print") {
      const w = window.open(href, "_blank");
      if (!w) toast.error("Permita pop-ups para imprimir");
      else w.addEventListener("load", () => w.print());
    } else {
      const a = document.createElement("a");
      a.href = href; a.download = filename; a.click();
    }
  } catch (e) {
    const d = e.response?.data instanceof Blob ? JSON.parse(await e.response.data.text()).detail : null;
    toast.error(d || "Falha ao gerar o diário");
  }
}

export const PdfButtons = ({ path, params, filename, disabled, testid, label = "PDF do diário" }) => {
  const [busy, setBusy] = useState("");
  const run = async (mode) => { setBusy(mode); await fetchPdf(path, params, mode, filename); setBusy(""); };
  return (
    <div className="flex gap-2">
      <Button variant="outline" size="sm" disabled={disabled || !!busy} onClick={() => run("download")} data-testid={`${testid}-pdf`}>
        {busy === "download" ? <Loader2 className="mr-1.5 h-4 w-4 animate-spin" /> : <FileText className="mr-1.5 h-4 w-4" />}{label}
      </Button>
      <Button variant="outline" size="sm" disabled={disabled || !!busy} onClick={() => run("print")} data-testid={`${testid}-print`}>
        {busy === "print" ? <Loader2 className="mr-1.5 h-4 w-4 animate-spin" /> : <Printer className="mr-1.5 h-4 w-4" />}Imprimir
      </Button>
    </div>
  );
};
